// extracted by mini-css-extract-plugin
export var container = "_if-0";
export var content = "_if-3";
export var customerTitle = "_if-4";
export var empty = "_if-5";
export var gray = "_if-6";
export var header = "_if-7";
export var info = "_if-8";
export var loading = "_if-2";
export var loadingCard = "_if-9";
export var oneLine = "_if-a";
export var personName = "_if-e";
export var pillContainer = "_if-b";
export var selected = "_if-1";
export var text = "_if-c";
export var twoLines = "_if-d";
export var unread = "_if-f";
export var unreadIndicator = "_if-g";